import { useState } from "react";
import styles from "../Styles/MoreCategoriesButton.module.css";

export default function MoreCategoriesButton({ categories, onSelect }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.wrap}>
      <button
        className={styles.btn}
        onClick={() => setOpen(o => !o)}
      >
        Lisää…
      </button>

      {open && (
        <div className={styles.menu}>
          {categories.map(cat => (
            <div
              key={cat}
              className={styles.item}
              onClick={() => {
                onSelect(cat);
                setOpen(false);
              }}
            >
              {cat}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
